import { Injectable } from "@angular/core";
import { Http, Headers } from "@angular/http";
import { map } from 'rxjs/operators';
import { GLOBAL } from './global';

@Injectable()
export class UserService {
    [x: string]: any;

    public url;
    public identity;
    public token;
    constructor(private _http: Http) {
        this.url = GLOBAL.url;
    }


    getPropietario(rut) {
        let params = {
            rut: rut
        };

        let headers = new Headers({
            'Content-type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        })

        return this._http.post(this.url + 'get/propietario', params, { headers: headers })
            .pipe(map(res => res.json()));
    }

    savePropietario(user) {
        let headers = new Headers({
            'Content-type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        });
        //console.log("save propietario user:",user)
        return this._http.post(this.url + 'save/propietario', user, { headers: headers })
            .pipe(map(res => res.json()));
    }
    saveRepresentante(user) {
        let headers = new Headers({
            'Content-type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        });
        return this._http.post(this.url + 'save/representante', user, { headers: headers })
            .pipe(map(res => res.json()));
    }
    getRepresentante(rut) {
        let params = {
            rut: rut
        };

        let headers = new Headers({
            'Content-type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        })

        return this._http.post(this.url + 'get/representante', params, { headers: headers })
            .pipe(map(res => res.json()));
    }

    saveinspector_obra(user) {
        let headers = new Headers({
            'Content-type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        });
        return this._http.post(this.url + 'save/inspectorObra', user, { headers: headers })
            .pipe(map(res => res.json()));
    }
    getinspector_obra(rut) {
        let params = {
            rut: rut
        };

        let headers = new Headers({
            'Content-type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        })

        return this._http.post(this.url + 'get/inspectorObra', params, { headers: headers })
            .pipe(map(res => res.json()));
    }

    saveprofesional_comp(user) {
        let headers = new Headers({
            'Content-type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        });
        return this._http.post(this.url + 'save/profesionComp', user, { headers: headers })
            .pipe(map(res => res.json()));
    }
    getprofesional_comp(rut) {
        let params = {
            rut: rut
        };

        let headers = new Headers({
            'Content-type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        })

        return this._http.post(this.url + 'get/profesionComp', params, { headers: headers })
            .pipe(map(res => res.json()));
    }

    getArquitecto(rut) {
        let params = {
            rut: rut
        };

        let headers = new Headers({
            'Content-type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        })

        return this._http.post(this.url + 'get/arquitecto', params, { headers: headers })
            .pipe(map(res => res.json()));
    }

    saveArquitecto(user) {
        let headers = new Headers({
            'Content-type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        });
        return this._http.post(this.url + 'save/arquitecto', user, { headers: headers })
            .pipe(map(res => res.json()));
    }



    getIndependiente(rut) {
        let params = {
            rut: rut
        };

        let headers = new Headers({
            'Content-type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        })

        return this._http.post(this.url + 'get/independiente', params, { headers: headers })
            .pipe(map(res => res.json()));
    }

    saveIndependiente(user) {
        let headers = new Headers({
            'Content-type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        });
        return this._http.post(this.url + 'save/independiente', user, { headers: headers })
            .pipe(map(res => res.json()));
    }

    getEmpresa(rut) {
        let params = {
            rut: rut
        };

        let headers = new Headers({
            'Content-type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        })

        return this._http.post(this.url + 'get/empresa', params, { headers: headers })
            .pipe(map(res => res.json()));
    }

    saveEmpresa(user) {
        let headers = new Headers({
            'Content-type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        });
        return this._http.post(this.url + 'save/empresa', user, { headers: headers })
            .pipe(map(res => res.json()));
    }

    getConstructores(rut) {
        let params = {
            rut: rut
        };

        let headers = new Headers({
            'Content-type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        })

        return this._http.post(this.url + 'get/constructores', params, { headers: headers })
            .pipe(map(res => res.json()));
    }

    saveConstructores(user) {
        let headers = new Headers({
            'Content-type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        });
        return this._http.post(this.url + 'save/constructores', user, { headers: headers })
            .pipe(map(res => res.json()));
    }

    getConstructora(rut) {
        let params = {
            rut: rut
        };

        let headers = new Headers({
            'Content-type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        })

        return this._http.post(this.url + 'get/constructora', params, { headers: headers })
            .pipe(map(res => res.json()));
    }

    saveConstructora(user) {
        let headers = new Headers({
            'Content-type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        });
        return this._http.post(this.url + 'save/constructora', user, { headers: headers })
            .pipe(map(res => res.json()));
    }

    getCalculista(rut) {
        let params = {
            rut: rut
        };

        let headers = new Headers({
            'Content-type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        })

        return this._http.post(this.url + 'get/calculista', params, { headers: headers })
            .pipe(map(res => res.json()));
    }

    saveCalculista(user) {
        let headers = new Headers({
            'Content-type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        });
        return this._http.post(this.url + 'save/calculista', user, { headers: headers })
            .pipe(map(res => res.json()));
    }

    getRevisor(rut) {
        let params = {
            rut: rut
        };

        let headers = new Headers({
            'Content-type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        })

        return this._http.post(this.url + 'get/revisor', params, { headers: headers })
            .pipe(map(res => res.json()));
    }

    saveRevisor(user) {
        let headers = new Headers({
            'Content-type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        });
        return this._http.post(this.url + 'save/revisor', user, { headers: headers })
            .pipe(map(res => res.json()));
    }

    login(rut, password, getToken = null) {
        var params;
        if (getToken != null) {
            params = {
                rut: rut,
                password: password,
                getToken: getToken
            }
        } else {
            params = {
                rut: rut,
                password: password
            }
        }
        let headers = new Headers({
            'Content-Type': 'application/json'
        });

        return this._http.post(this.url + 'user/login', params, { headers: headers })
            .pipe(map(res => res.json()));
    }

    register(user) {
        let params = {
            rut: user.controls.rut.value,
            nombres: user.controls.nombres.value,
            apellidoP: user.controls.apellidoP.value,
            apellidoM: user.controls.apellidoM.value,
            calle: user.controls.calle.value,
            numero: user.controls.numero.value,
            complemento: user.controls.complemento.value,
            comuna: user.controls.comuna.value,
            email: user.controls.email.value,
            telefono: user.controls.telefono.value,
            password: user.controls.passwords.controls.password.value
        }
        let headers = new Headers({
            'Content-Type': 'application/json'
        });
        return this._http.post(this.url + 'user/register', params, { headers: headers })
            .pipe(map(res => res.json()));
    }

    buscarUsuario(rut) {
        let headers = new Headers({
            'Content-Type': 'application/json'
        })
        let params = {
            rut: rut
        }
        return this._http.post(this.url + 'user/find', params, { headers: headers })
            .pipe(map(res => res.json()));
    }

    saveDraft(name, draft) {
        let headers = new Headers({
            'Content-Type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        })

        console.log("aca vá el borrador", draft);
        let params = {
            name: name,
            draft: draft,
            form: localStorage.getItem("form")
        }
        return this._http.post(this.url + 'user/save/draft', params, { headers: headers })
            .pipe(map(res => res.json()));
    }

    getDrafts() {
        let headers = new Headers({
            'Content-Type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        });
        return this._http.get(this.url + 'user/get/drafts', { headers: headers })
            .pipe(map(res => res.json()));
    }

    getDraft(id) {
        let headers = new Headers({
            'Content-Type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        });
        let params = {
            formId: id
        }
        return this._http.post(this.url + 'user/get/draft', params, { headers: headers })
            .pipe(map(res => res.json()));
    }


    getIdentity() {
        let identity = JSON.parse(sessionStorage.getItem('identity-domCloud'));

        if (identity != "undefined") {
            this.identity = identity;
        } else {
            this.identity = null;
        }

        return this.identity;
    }

    getToken() {
        let token = sessionStorage.getItem('token-domCloud');

        if (token != undefined) {
            this.token = token;
        } else {
            this.token = null;
        }

        return this.token;
    }

    getActiveCertificado() {
        let token = sessionStorage.getItem('activeCertificado');

        if (token != undefined) {
            this.token = token;
        } else {
            this.token = null;
        }

        return this.token;
    }

    deleteDraft(id) {
        let headers = new Headers({
            'Content-Type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        });
         let params = {
            id: id
        }


        return this._http.post(this.url + 'draft/delete', params, { headers: headers })
            .pipe(map(res => res.json()));
    }

    updateDraft(id, draft) {
        let headers = new Headers({
            'Content-Type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        });
        let params = {
            draft: draft,
            draftId: id
        }
        return this._http.post(this.url + 'draft/update', params, { headers: headers })
            .pipe(map(res => res.json()));
    }





    updatePhoto(img) {
        let headers = new Headers({
            'Content-Type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        });
        let params = {
            img: img
        }
        return this._http.post(this.url + 'user/profile/img/update', params, { headers: headers })
            .pipe(map(res => res.json()));
    }

    formMostUsed(id, title) {
        let headers = new Headers({
            'Content-Type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        });
        let params = {
            num: id,
            title: title,
            counter: 1
        }
        return this._http.post(this.url + 'forms/update/most', params, { headers: headers })
            .pipe(map(res => res.json()));
    }

    getFormUser() {

        let headers = new Headers({
            'Content-Type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        });

        return this._http.get(this.url + 'forms/get/most', { headers: headers })
            .pipe(map(res => res.json()));
    }

    getSolicitudes() {
        let headers = new Headers({
            'Content-Type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        });

        //console.log( "solicitudes", this._http.get(this.url+'solicitudes/expedientes/get', {headers:headers}) );

        return this._http.get(this.url + 'solicitudes/expedientes/get', { headers: headers })
            .pipe(map(res => res.json()));
    }

    activeUser(token) {
        let headers = new Headers({
            'Content-Type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        });
        let params = {
            token: token
        }

        return this._http.post(this.url + 'user/active', params, { headers: headers })
            .pipe(map(res => res.json()));
    }

    getComunas() {
        let headers = new Headers({
            'Content-Type': 'application/json',
        });


        return this._http.get(this.url + 'comunas', { headers: headers })
            .pipe(map(res => res.json()));
    }

    getRegiones() {
        let headers = new Headers({
            'Content-Type': 'application/json',
        });


        return this._http.get(this.url + 'regiones', { headers: headers })
            .pipe(map(res => res.json()));
    }

    resendMailActivation(email) {
        let headers = new Headers({
            'Content-Type': 'application/json'
        });

        var params = {
            email: email
        }

        return this._http.post(this.url + 'email/resend', params, { headers: headers })
            .pipe(map(res => res.json()));
    }

    marcarSolicitud(solicitud) {
        let headers = new Headers({
            'Content-Type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        });
        let params = {
            solicitud: solicitud
        }
        return this._http.post(this.url + 'solicitud/marcar', params, { headers: headers })
            .pipe(map(res => res.json()));
    }

    sendMailResetPass(rut, email) {
        let headers = new Headers({
            'Content-Type': 'application/json'
        });

        var params = {
            rut: rut,
            mail: email
        }

        return this._http.post(this.url + 'email/reset/pass', params, { headers: headers })
            .pipe(map(res => res.json()));
    }

    resetPass(rut, password) {
        let headers = new Headers({
            'Content-Type': 'application/json'
        });

        var params = {
            rut: rut,
            pass: password
        }

        return this._http.post(this.url + '/user/reset/pass', params, { headers: headers })
            .pipe(map(res => res.json()));
    }

    get_solicitudd_dom(rut, exp, sol) {
        let headers = new Headers({
            'Content-Type': 'application/json'
        })

        let paramas = {
            rut: rut,
            exp: exp,
            sol: sol
        }

        return this._http.post(this.url + 'user/get_solicitud_dom', paramas, { headers: headers })
            .pipe(map(res => res.json()));
    }

    get_calculo_derecho(rut, exp, sol) {
        console.log("entre en service ", rut, exp, sol)
        let headers = new Headers({
            'Content-Type': 'application/json'
        })

        let paramas = {
            rut: rut,
            exp: exp,
            sol: sol
        }

        return this._http.post(this.url + 'user/get_calculo_derecho', paramas, { headers: headers })
            .pipe(map(res => res.json()));
    }

    insertar_calculo(rut, sol) {
        console.log(rut)
        let headers = new Headers({
            'Content-Type': 'application/json'
        })

        let paramas = {
            rut: rut,
            sol: sol
        }

        return this._http.post(this.url + 'user/insertar_calculo', paramas, { headers: headers })
            .pipe(map(res => res.json()));
    }

    actualizar_calculo(rut, sol) {
        console.log(rut)
        let headers = new Headers({
            'Content-Type': 'application/json'
        })

        let paramas = {
            rut: rut,
            sol: sol
        }

        return this._http.post(this.url + 'user/actualizar_calculo', paramas, { headers: headers })
            .pipe(map(res => res.json()));
    }

    traerInfo_rut(rut) {
        let headers = new Headers({
            'Content-Type': 'application/json'
        })
        let params = {
            rut: rut
        }
        return this._http.post(this.url + 'user/getinfo_rut', params, { headers: headers })
            .pipe(map(res => res.json()));
    }

    getInfoRutSolicitante(rut) {
        let headers = new Headers({
            'Content-Type': 'application/json'
        })
        let params = {
            rut: rut
        }
        return this._http.post(this.url + 'cert/getInfoRutSolicitante', params, { headers: headers })
            .pipe(map(res => res.json()));
    }

    save_info_mod_solicitante(rut, data) {
        let headers = new Headers({
            'Content-Type': 'application/json'
        })
        let params = {
            rut: rut,
            data: data
        }
        return this._http.post(this.url + 'cert/guardar_mod_solicitante', params, { headers: headers })
            .pipe(map(res => res.json()));
    }

    save_solicitante(user) {
        let headers = new Headers({
            'Content-Type': 'application/json'
        })

        let paramas = {
            user: user
        }

        return this._http.post(this.url + 'user/saveSolicitante', paramas, { headers: headers })
            .pipe(map(res => res.json()));
    }

    get_valores_cert() {
        let headers = new Headers({
            'Content-Type': 'application/json'
        })

        return this._http.post(this.url + 'cert/get_valores_cert', { headers: headers })
            .pipe(map(res => res.json()));
    }

    traerInfo_propiedad_rol(rol) {
        let headers = new Headers({
            'Content-Type': 'application/json'
        })
        let params = {
            rol: rol
        }
        return this._http.post(this.url + 'user/getinfo_propiedad_rol', params, { headers: headers })
            .pipe(map(res => res.json()));
    }

    traerInfo_propiedad_direccion(calle, num) {
        let headers = new Headers({
            'Content-Type': 'application/json'
        })
        let params = {
            calle: calle,
            num: num
        }
        return this._http.post(this.url + 'user/getinfo_propiedad_direccion', params, { headers: headers })
            .pipe(map(res => res.json()));
    }

    consultar_rut_propietario(rut, folio) {
        let headers = new Headers({
            'Content-Type': 'application/json'
        })
        let params = {
            rut: rut,
            folio: folio
        }
        return this._http.post(this.url + 'user/consultar_propietario', params, { headers: headers })
            .pipe(map(res => res.json()));
    }

    get_observaciones(rut, exp, sol) {
        let headers = new Headers({
            'Content-Type': 'application/json'
        })

        let paramas = {
            rut: rut,
            exp: exp,
            sol: sol
        }

        return this._http.post(this.url + 'user/get_observaciones', paramas, { headers: headers })
            .pipe(map(res => res.json()));
    }

    ingreso_obs(sol, exp, glosa, link, inforut) {
        let headers = new Headers({
            'Content-Type': 'application/json'
        })
        console.log("ruttt", inforut)

        let paramas = {
            sol: sol,
            exp: exp,
            glosa: glosa,
            link: link,
            inforut: inforut
        }

        return this._http.post(this.url + 'user/ingreso-obs', paramas, { headers: headers })
            .pipe(map(res => res.json()));
    }

    finalizarProceso(datos) {
        let headers = new Headers({
            'Content-Type': 'application/json'
        })

        let params = {
            datos: datos
        }

        return this._http.post(this.url + 'cert/beforePago', params, { headers: headers })
            .pipe(map(res => res.json()));
    }

    finalizarProcesoPresencial(data) {
        let headers = new Headers({
            'Content-Type': 'application/json'
        })

        return this._http.post(this.url + 'cert/pagoPresencial', data, { headers: headers })
            .pipe(map(res => res.json()));
    }

    getFormularios() {
        let params = {

        };
        let headers = new Headers({
            'Content-Type': 'application/json'
            //,'Authorization': sessionStorage.getItem("token-domCloud")
        })
        return this._http.post(this.url + 'forms/getFormularios', params, { headers: headers })
            .pipe(map(res => res.json()));
    }

    get_pagos_cert_prov(fecha_ingreso) {
        let headers = new Headers({
            'Content-Type': 'application/json'
        })

        let params = {
            fecha_ingreso: fecha_ingreso
        }

        return this._http.post(this.url + 'user/get_pagos_cert_prov', params, { headers: headers })
            .pipe(map(res => res.json()));
    }


    getPatente(rutContribuyente, año, numSoli) {
        let params = {
            rutContribuyente: rutContribuyente,
            año: año,
            numSoli: numSoli
        };

        let headers = new Headers({
            'Content-type': 'application/json',
        })

        return this._http.post(this.url + 'get/patentes', params, { headers: headers })
            .pipe(map(res => res.json()));

    }

}